module.exports = __webpack_public_path__ + "static/media/camera-on.6c2297fb.svg";